module.exports = __webpack_public_path__ + "assets/42cc4a0ff2acbc3c7bb58f9d658d42af.woff";